import React from "react";
import "./Footer.css";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { IoMail, IoCall, IoLocationSharp, IoArrowUp } from "react-icons/io5";
import { useTranslation } from "react-i18next";

import Logo from "../assets/image/sorifap.png"; 

const Footer = () => {

  const [t] = useTranslation("global");

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer className="footer">

      <div className="footerContainer">


        <div className="footerLeft">
          <img src={Logo} alt="SORIFAP Logo" className="footerLogo" />
          <h3>{t("footer.tagline")}</h3>
          <p>{t("footer.description")}</p>
        </div>


        <div className="footerRight">

          <div className="contactItem">
            <IoLocationSharp />
            <span>{t("footer.address")}</span>
          </div>

          <div className="contactItem">
            <IoCall />
            <span>{t("footer.phone")}</span>
          </div>

          <div className="contactItem">
            <IoMail />
            <span>{t("footer.email")}</span>
          </div>

          <div className="socialIcons">
            <a href="https://www.facebook.com/sorifap2000/" target="_blank" rel="noreferrer"><FaFacebookF /></a>
            <a href="https://www.linkedin.com/company/104781998/" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
            <a href="https://www.instagram.com/sorifap1/" target="_blank" rel="noreferrer"><FaInstagram /></a>
          </div>

        </div>
      </div>


      <div className="footerDivider"></div>


      <div className="footerBottom">
        <p>© {new Date().getFullYear()} SORIFAP Powered By Raven Dev Services. {t("footer.rights")}</p>
      </div>

   
      <button className="backToTop" onClick={scrollToTop}>
        <IoArrowUp />
      </button>

    </footer>
  );
};

export default Footer;